if (typeof ToastsComponent !== 'function') {
	class ToastsComponent extends HTMLElement {
		constructor() {
			super();

			this.show_after = this.dataset.showAfter ? this.dataset.showAfter * 1000 : 0;
			this.ref = this.dataset.ref ?? null;
			this.type = this.dataset.type ?? null;
			this.close_after = this.dataset.closeAfter ? this.dataset.closeAfter * 1000 : 0;

			this.selectors = {
				toast: '.toast-item',
				close: '[data-toast-close]',
			};

			this.classes = {
				visible: 'toast-item--visible',
			};

			// Elements
			this.toast = this.querySelector(this.selectors.toast);
			this.close = this.querySelector(this.selectors.close);

			this.init();
		}

		init() {
			const { toast, close_after } = this;

			this.loadFeatures();
			this.showToast();
			this.addEventListeners();

			if (close_after > 0) {
				setTimeout(
					function () {
						this.closeToast();
					}.bind(this),
					close_after
				);
			}
		}

		addEventListeners() {
			const { type, close } = this;

			if (type === 'cookies') {
				close.addEventListener('click', this.handleAccept.bind(this));
			} else {
				close.addEventListener('click', this.closeToast.bind(this));
			}
		}

		showToast() {
			if (this.toastFound()) return;

			const { toast, show_after, type } = this;

			if (type === 'cookies') {
				window.addEventListener('load', function () {
					const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
					const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

					if (!userCanBeTracked && userTrackingConsent === 'no_interaction') {
						setTimeout(function () {
							toast.classList.toggle('toast-item--visible');
						}, show_after);
					}
				});
			} else if (type === 'subscription') {
				window.addEventListener('load', function () {
					const urlParams = new URLSearchParams(window.location.search);
					const customerPosted = JSON.parse(urlParams.get('customer_posted'));

					if (customerPosted === true) {
						toast.classList.toggle('toast-item--visible');
					}
				});
			} else {
				setTimeout(function () {
					toast.classList.toggle('toast-item--visible');
				}, show_after);
			}
		}

		closeToast() {
			if (this.toastFound()) return;

			const { toast, ref, type } = this;

			let toasts = localStorage.getItem('toasts') ? JSON.parse(localStorage.getItem('toasts')) : [];
			if (type !== 'subscription') {
				toasts.push(ref);
				localStorage.setItem('toasts', JSON.stringify(toasts));
			}

			if (toast.classList.contains('toast-item--visible')) {
				toast.classList.remove('toast-item--visible');
			}
		}

		toastFound() {
			const toasts = localStorage.getItem('toasts') ? JSON.parse(localStorage.getItem('toasts')) : [];

			return toasts.includes(this.ref);
		}

		handleAccept() {
			const callback = () => {
				this.closeToast();
			};

			window.Shopify.customerPrivacy.setTrackingConsent(true, callback);
		}

		handleDecline() {
			window.Shopify.customerPrivacy.setTrackingConsent(false);
		}

		loadFeatures() {
			window.Shopify.loadFeatures(
				[
					{
						name: 'consent-tracking-api',
						version: '0.1',
					},
				],
				function (error) {
					if (error) {
						throw error;
					}
				}
			);
		}
	}

	if (!customElements.get('toast-component')) {
		customElements.define('toast-component', ToastsComponent);
	}
}
